/**
 * Small fetch wrapper for the Telehealth Platform backend REST API.
 *
 * Constructs tenant-prefixed URLs automatically. The current tenant slug is read
 * from the `<html data-tenant-slug="...">` attribute injected by the backend
 * when serving application HTML shells. When no slug is present the URL remains
 * root-relative, preserving local development and neutral platform pages.
 */
function getTenantSlug() {
  if (typeof document === 'undefined') return '';
  return document.documentElement.dataset.tenantSlug || '';
}

function tenantPrefix() {
  const slug = getTenantSlug();
  return slug ? `/${slug}` : '';
}

export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${tenantPrefix()}/api${path}`, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  });
  let data = null;
  try {
    data = await res.json();
  } catch (_err) {
    data = null;
  }
  if (!res.ok) {
    const error = new Error((data && data.error) || `request_failed_${res.status}`);
    error.status = res.status;
    error.data = data;
    throw error;
  }
  return data;
}
